module.exports = __webpack_public_path__ + "images/avatars/female/12.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/12.svg
// module id = 4zkA
// module chunks = 118